import React, { Component , useState } from 'react';
import { Form, Label , Input, Button, Grid, Message, Select , Radio } from 'semantic-ui-react';
import DatePicker , { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { estados } from './Estados.js'; 

registerLocale('es', es)
/*
const tipoSolicitud = [
    { key: '1', value: '1', text: 'Solicitud tipo 01' },
    { key: '2', value: '2', text: 'Solicitud tipo 02' },
    { key: '3', value: '3', text: 'Solicitud tipo 03' }
]
*/
export default class FormFiltro03 extends Component {
    
    constructor(props) {
      super(props);
      this.state = {
        type: this.props.type,
        radioGroup: null,
        cbTipoSol:'',
        coments: '',
        model: null, 
        length: null,
        errors: [], 
        
        isLoaded: false,
        dataFiltro: {},
        tipoSolicitud: [],
        alternativas: []

      }
      this._onChange = this._onChange.bind(this);
      this._onclicSeleccionar = this._onclicSeleccionar.bind(this);
      this._validate = this._validate.bind(this);
      this._handleRbChangeMethod = this._handleRbChangeMethod.bind(this); 
      this._back = this._back.bind(this);
    }
  
    _back(e) {
      e.preventDefault();
      this.props.back(estados.FILTRO_2);
    }
  
    _validate(e) {
      e.preventDefault();
      /*
        this.props.saveForm({
            cbTipoSol : this.state.cbTipoSol,
            coments: this.state.coments,
            radioGroup: this.state.radioGroup
        });
        */
        this.saveForTipoSol();
        //this.props.next(this.props.nextState);
    }

    /** Tres formas y metodos distintos para hacer lo mismo */
    _onChange(e, { name, value }) {
        let METHODNAME = '_onChange - ';
        //console.log(METHODNAME + 'name = ' + name + '; value=' + value );
        this.setState({
          [name]: value
        });
    }
    
    _onclicSeleccionar() {
      let METHODNAME = '_onclicSeleccionar - ';
      console.log(METHODNAME + 'INI');

      console.log(METHODNAME + 'Llamar a servicio y actualizar items para ' + this.state.cbTipoSol );
      this.getAlternativasForTipoSol();

      console.log(METHODNAME + 'FIN');
    }

    handleRbChangeConst = (e, { value }) => {
        let METHODNAME = 'handleRbChangeConst - ';
        console.log(METHODNAME + 'INI');
        
        this.setState({
            radioGroup: value
        });
    }
     
    _handleRbChangeMethod (e, { value }) {
        let METHODNAME = '_handleRbChangeMethod - ';
        console.log(METHODNAME + 'INI');

        this.setState({
            radioGroup: value
        });
    }
    
    componentDidMount() {
      let METHODNAME = 'componentDidMount - ';
      console.log(METHODNAME + 'INI');

      fetch("http://localhost:8080/restForm03")
      .then(res => res.json())
      .then(
          (result) => {
              this.setState({
                  isLoaded: true,
                  dataFiltro: result.result,
                  tipoSolicitud: result.result.tipoSolicitud,
                  alternativas: result.result.alternativas
              });
          },
          
          (error) => {
              console.log(METHODNAME + 'error = ' + error );
              this.setState({
                  isLoaded: true,
                  error
              });
          }
      )
      console.log(METHODNAME + 'FIN');
    }

    async getAlternativasForTipoSol() {
      let METHODNAME = 'getAlternativasForTipoSol - ';
      console.log(METHODNAME + 'INI');

      let idTipoSol = this.state.cbTipoSol;
      let url =  `http://localhost:8080/restForm03/${idTipoSol}`;

      this.setState({
        radioGroup: null
      });

      const json = await fetch( url , {
          method: 'GET',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json'
          }
      }).then((result) => {
          console.log(METHODNAME + 'analisar resultado.');
          result.json().then((resp) => {

              console.warn(METHODNAME + 'resultado = ' + resp.result.alternativas);
              if( resp.result.alternativas ){
                this.setState({
                  alternativas: resp.result.alternativas
                });
              }else {
                  this.setState({
                      errors: ['Error enviado por el servicio: ' + resp.result.error ]
                  });
              }
             
          })
      })

      return json ;
    }

    async saveForTipoSol( ) {
      let METHODNAME = 'saveForTipoSol - ';
      console.log(METHODNAME + 'INI');

      let idTipoSol = this.state.cbTipoSol;
      let url =  `http://localhost:8080/restForm03/${idTipoSol}`;

      let dataForm ={
        cbTipoSol : this.state.cbTipoSol,
        radioGroup : this.state.radioGroup,
        coments : this.state.coments
      }

      const json = await fetch( url , {
          method: 'POST',
          headers:{
              'Accept':'application/json',
              'Content-Type':'application/json'
          },
          body:JSON.stringify(dataForm)
      }).then((result) => {
          console.log(METHODNAME + 'analisar resultado.');
          result.json().then((resp) => {

            if( resp.result.resultado === 'APROBADO'){
              this.props.next(estados.FILTRO_4);
            }else if(resp.result.resultado === 'RECHAZADO'){
                this.props.next(estados.RECHAZADO);
                /*this.setState({
                  errors: ['REST: ' + resp.result.mensaje  ]
                });*/
            }else {
                this.setState({
                    errors: ['Error enviado por el servicio: ' + resp.result.error  ]
                });
            }
             
          })
      }) 
  }

    render() {

      /**
       * 
                <Form.Field>
                    <Radio
                        label='Cumple con el requisito 01'
                        name='radioGroup'
                        value='01'
                        checked={this.state.radioGroup === '01'}
                        onChange={this.handleRbChangeConst}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Cumple con el requisito 02'
                        name='radioGroup'
                        value='02'
                        checked={this.state.radioGroup === '02'}
                        onChange={this._handleRbChangeMethod}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='Cumple con el requisito 03'
                        name='radioGroup'
                        value='03'
                        checked={this.state.radioGroup === '03'}
                        onChange={this._onChange}
                    />
                </Form.Field>
                
       */

      const { error, isLoaded, dataFiltro , preguntas } = this.state;

      if (error) {
          return <div>Error: {error.message}</div>;
      } else if (!isLoaded) {
          return <div>Loading...</div>;
      } else {

        return(
          <Form>
            
            { this.state.errors.length > 0 &&
            <Message negative>
              <p>{this.state.errors.join('. ')}</p>
            </Message>
            }
              <h2>{dataFiltro.nombreFiltro}:</h2>
              <h3>{dataFiltro.dataFiltro}:</h3>
  
              <Form.Field inline>
                
                  <Form.Group widths='equal'>
                      <Form.Field inline>
                          <label>Tipo de Solicitud:</label> 
                          <Select 
                              id='cbTipoSol'
                              name='cbTipoSol'
                              placeholder='Seleccione el Tipo de Solicitud' 
                              options={this.state.tipoSolicitud}
                              onChange={this._onChange}
                          />
                          <Button onClick={this._onclicSeleccionar}>Seleccionar</Button>
                      </Form.Field>
                  </Form.Group>
  
                  {this.state.alternativas.map(item => (
                      <Form.Field key={item.id}>
                        <Radio
                            id={item.name+'_'+item.id}
                            label={item.label}
                            name={item.name}
                            value={item.value}
                            checked={this.state.radioGroup === item.value}
                            onChange={this._onChange}
                        />
                    </Form.Field>
                  ))}
                  
                  <Form.Field inline> 
                      <Form.Input 
                          id='txtComents'
                          name='coments'
                          value={this.state.coments}
                          onChange={this._onChange}
                          label='Comentarios:' 
                          placeholder='Ingrese sus comentarios'/>
                  </Form.Field>
  
  
              </Form.Field>
  
            <Grid>
              <Grid.Column floated='left' width={5}>
                <Button secondary onClick={this._back}>Back</Button>
              </Grid.Column>
              <Grid.Column floated='right' width={5}>
                <Button primary onClick={this._validate}>Next</Button>
              </Grid.Column>
            </Grid>
  
          </Form>
        );
      }
      
    }
}
 